

export const REU = (
    <div>
        <span><p className="title"><b>Research Experience for Undergraduates(REU)</b></p></span>
        <p>
            <b className="programs-span">2024 – SDNI Research Experience for Undergrads (REU)</b>
            <br /><br />
            The goal of this program is to provide undergrads with research experience in the field of nanotechnology as well as professional development through programmatic activities which enriches their experiential learning and better prepare them for graduate school. Please take note that each selected participant will be assigned to a faculty mentor involved with nanotechnology research, and specific research area will depend on faculty’s availability. Participation in all weekly programmatic activities is essential to successfully complete the program. At the end of the program, REU students will have the opportunity to present their research project outcomes at the NNCI Annual REU convocation as well as the UCSD Summer Research Conference.
            <br /><br />

            <ol>
                <li>SDNI will accept 7 candidates to its Summer 2024 REU program.</li>
                <li>Stipend: $6,000.</li>
                <li>Travel expenses: One round trip ticket (coach class) from home to UC San Diego and one round trip ticket (coach class) from San Diego to NNCI REU Convocation (site/City TBD).</li>
                <li>On-Campus lodging provided for the entire duration of the program.</li>
                <li>Food is not provided.</li>
            </ol>
            {/* Application start November 15, 2022. SDNI will accept 6 candidates to its REU program in 2023. */}
            {/*To apply, please click <a*/}
            {/*                    href="https://docs.google.com/forms/d/e/1FAIpQLSe5c7tMehAlQEfCWYepwWz4-OLrqdra_ovEjIpKfBUY5icciw/viewform?usp=sf_link"*/}
            {/*                    target="_blank">Here</a>. */}
            {/*<br />*/}

            {/*Application Deadline: February 16, 2024.*/}
            {/*<br />*/}
            {/*Results will be announced between March 1, and March 15, 2024.*/}
            <br />
            Application period closed.
            <br /><br />
            {/* <b className="programs-span">To apply, please click on the following link:&nbsp;</b>
            <a href="https://sdni.reumanager.co/" target="_blank">SDNI REU 2023 - Apply</a> */}
        </p>
    </div>
)
